import get from 'lodash/get';
import includes from 'lodash/includes';
import toLower from 'lodash/toLower';

import { availableNamedLanguages } from '@savgroup-front-common/constants';
import { changeLocaleLanguage } from '@savgroup-front-common/core/domains/i18n/actions';
import { getSellers } from '@savgroup-front-common/core/domains/sellers/actionCreators';
import { defaultLanguage, intl } from '@savgroup-front-common/core/helpers';

import { AuthorizationService } from '@/api';

const loginSignedIn =
  ({ payload, setLoginStore }) =>
  (dispatch) => {
    const preferedLanguage =
      toLower(get(payload, 'preferences.language')) ||
      toLower(navigator.language).slice(0, 2);
    const chosenLanguage = includes(availableNamedLanguages, preferedLanguage)
      ? preferedLanguage
      : defaultLanguage;

    if (chosenLanguage && !intl.locale) {
      dispatch(changeLocaleLanguage({ locale: chosenLanguage }));
    }
    setLoginStore(payload);
  };

export const signIn =
  ({ onLogin, setLoginStore }) =>
  async (dispatch) => {
    try {
      const result = await AuthorizationService.login();

      if (onLogin) {
        onLogin();
      }

      const payload = {
        isLoaded: true,
        ...result.value,
        failure: result.failure,
        errors: result.errors,
      };

      dispatch(getSellers({ forceRefresh: true }));
      dispatch(loginSignedIn({ payload, setLoginStore }));
    } catch (errors) {
      const payload = {
        isLoaded: true,
        failure: true,
        errors,
      };

      dispatch(loginSignedIn({ payload, setLoginStore }));
    }
  };
